// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/nav-hover-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  width: 100%;
  height: 72px;
  background-color: #982D67;
  padding-top: 20px;
  color: #FFFFFF;
  position: fixed;
  z-index: 1000;
  top: -100%;
  transition: top 1s cubic-bezier(0.4, 0, 0.2, 1), background-color 1s ease-in-out;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1620px) {
  .header {
    height: 80px;
  }
}
@media (max-width: 550px) {
  .header {
    height: 60px;
  }
}
.header.visible {
  top: -1px;
}
.header.hide {
  top: -100%;
}
.header.open {
  background-color: #812456;
}
.header .header-container {
  width: calc(100% - 160px);
  height: calc(100% - 2px);
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
@media (min-width: 1620px) {
  .header .header-container {
    width: calc(100% - 200px);
  }
}
@media (max-width: 1050px) {
  .header .header-container {
    width: calc(100% - 80px);
  }
}
@media (max-width: 550px) {
  .header .header-container {
    width: calc(100% - 32px);
  }
}
.header .header-container.border {
  border-bottom: 2px solid #FFFFFF;
}
.header .header-container .header-line {
  width: 100%;
  position: absolute;
  top: 0px;
  height: 2px;
  background-color: #FFFFFF;
}
.header .header-container .header-logo {
  height: 20px;
}
@media (min-width: 1620px) {
  .header .header-container .header-logo {
    height: 24px;
  }
}
.header .header-container .header-logo img {
  height: 100%;
}
.header .header-container .header-navigator {
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media (max-width: 1050px) {
  .header .header-container .header-navigator {
    width: 100%;
    height: calc(100svh - 92px);
    position: fixed;
    z-index: 999;
    top: 100%;
    left: 0;
    background-color: #812456;
    transition: top 1s ease-in-out;
  }
}
@media (max-width: 1050px) and (max-width: 550px) {
  .header .header-container .header-navigator {
    height: calc(100vh - 79px);
  }
}
@media (max-width: 1050px) {
  .header .header-container .header-navigator.open {
    top: 91px;
  }
}
@media (max-width: 1050px) and (max-width: 550px) {
  .header .header-container .header-navigator.open {
    top: 79px;
  }
}
.header .header-container .header-navigator .header-navigator-container {
  width: 100%;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media (max-width: 1050px) {
  .header .header-container .header-navigator .header-navigator-container {
    height: calc(100% - 104px);
    padding-top: 104px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }
}
@media (max-width: 550px) {
  .header .header-container .header-navigator .header-navigator-container {
    height: calc(100% - 52px);
    padding-top: 52px;
  }
}
.header .header-container .header-navigator .header-navigator-container ul {
  gap: 112px;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-family: FixelDisplay;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
@media (min-width: 1620px) {
  .header .header-container .header-navigator .header-navigator-container ul {
    font-family: FixelDisplay;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
}
@media (max-width: 1200px) {
  .header .header-container .header-navigator .header-navigator-container ul {
    gap: 60px;
  }
}
@media (max-width: 1050px) {
  .header .header-container .header-navigator .header-navigator-container ul {
    margin-left: 40px;
    letter-spacing: -1.92px;
    gap: 32px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    font-family: FixelDisplay;
    font-size: 64px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
@media (max-width: 550px) {
  .header .header-container .header-navigator .header-navigator-container ul {
    margin-left: 16px;
    letter-spacing: -1.38px;
    gap: 24px;
    font-family: FixelDisplay;
    font-size: 46px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
  }
}
.header .header-container .header-navigator .header-navigator-container ul li {
  position: relative;
  cursor: pointer;
}
.header .header-container .header-navigator .header-navigator-container ul li::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: absolute;
  top: -3px;
  left: -16px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.header .header-container .header-navigator .header-navigator-container ul li::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: absolute;
  top: 1px;
  right: -16px;
  transform: rotate(180deg);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.header .header-container .header-navigator .header-navigator-container ul li:hover::before,
.header .header-container .header-navigator .header-navigator-container ul li:hover::after {
  opacity: 1;
}
.header .header-container .header-navigator .header-navigator-container .header-navigation-mobile-box {
  display: none;
}
@media (max-width: 1050px) {
  .header .header-container .header-navigator .header-navigator-container .header-navigation-mobile-box {
    display: block;
    width: 100%;
  }
}
.header .header-container .header-navigator .header-navigator-container .header-navigator-contacts {
  display: none;
}
@media (max-width: 1050px) {
  .header .header-container .header-navigator .header-navigator-container .header-navigator-contacts {
    display: block;
    margin-left: 40px;
    gap: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }
  .header .header-container .header-navigator .header-navigator-container .header-navigator-contacts .header-navigator-contacts-label {
    letter-spacing: 0.14px;
    text-transform: uppercase;
    font-family: FixelDisplay;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
  .header .header-container .header-navigator .header-navigator-container .header-navigator-contacts .header-navigator-contacts-box {
    gap: 16px;
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    font-family: FixelDisplay;
    font-size: 34px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
}
@media (max-width: 550px) {
  .header .header-container .header-navigator .header-navigator-container .header-navigator-contacts {
    margin-left: 16px;
    gap: 24px;
  }
  .header .header-container .header-navigator .header-navigator-container .header-navigator-contacts .header-navigator-contacts-label {
    letter-spacing: 0.14px;
    text-transform: uppercase;
    font-family: FixelDisplay;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
  }
  .header .header-container .header-navigator .header-navigator-container .header-navigator-contacts .header-navigator-contacts-box {
    gap: 16px;
    text-transform: uppercase;
    font-family: FixelDisplay;
    font-size: 25px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
.header .header-container .header-navigator .header-navigator-container .header-title {
  display: none;
}
@media (max-width: 1050px) {
  .header .header-container .header-navigator .header-navigator-container .header-title {
    width: 100%;
    margin-top: 50px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .header .header-container .header-navigator .header-navigator-container .header-title img {
    width: 100%;
  }
}
@media (max-width: 1050px) {
  .header .header-container .header-navigator .header-navigator-container .header-title {
    margin-top: 32px;
  }
}
.header .header-container .header-buttons-box {
  gap: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.header .header-container .header-buttons-box .header-button-email {
  width: 44px;
  height: 44px;
  position: relative;
  background-color: #FFFFFF;
  color: #982D67;
  border-radius: 1000px;
  transition: color 0.3s ease-in-out;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media (max-width: 1050px) {
  .header .header-container .header-buttons-box .header-button-email {
    display: none;
  }
}
.header .header-container .header-buttons-box .header-button-email svg {
  position: relative;
  z-index: 2;
}
.header .header-container .header-buttons-box .header-button-email::before {
  content: "";
  width: 46px;
  height: 46px;
  border-radius: 1000px;
  background-color: #982D67;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.3s ease-in-out;
  transform-origin: center;
}
.header .header-container .header-buttons-box .header-button-email:hover {
  color: #FFFFFF;
}
.header .header-container .header-buttons-box .header-button-email:hover::before {
  transform: translate(-50%, -50%) scale(1);
}
.header .header-container .header-buttons-box .header-button-menu {
  display: none;
}
@media (max-width: 1050px) {
  .header .header-container .header-buttons-box .header-button-menu {
    width: 40px;
    height: 40px;
    background-color: #FFFFFF;
    border-radius: 100px;
    position: relative;
    z-index: 3;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
.header .header-container .header-button-touch {
  height: 48px;
  padding: 0 8px 0 130px;
  background-color: #FFFFFF;
  color: #982D67;
  gap: 12px;
  border-radius: 1000px;
  text-transform: uppercase;
  position: relative;
  z-index: 3;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: FixelDisplay;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
}
@media (max-width: 1050px) {
  .header .header-container .header-button-touch {
    height: 40px;
  }
}
@media (max-width: 550px) {
  .header .header-container .header-button-touch {
    display: none;
  }
}
.header .header-container .header-button-touch .header-button-touch-text {
  width: 110px;
  height: 16px;
  margin-top: 4px;
  overflow: hidden;
  white-space: nowrap;
  position: absolute;
  left: 15px;
  display: inline-block;
}
.header .header-container .header-button-touch .header-button-touch-text.top .char {
  transform: translateY(0%);
}
.header .header-container .header-button-touch .header-button-touch-text.bottom .char {
  opacity: 0;
  transform: translateY(-100%);
}
.header .header-container .header-button-touch .header-button-touch-text .char {
  display: inline-block;
}
.header .header-container .header-button-touch .header-button-touch-pencil {
  width: 28px;
  height: 28px;
  position: relative;
  background-color: #982D67;
  border-radius: 1000px;
  transition: transform 0.3s ease-in-out;
  transform-origin: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media (max-width: 1050px) {
  .header .header-container .header-button-touch .header-button-touch-pencil {
    width: 24px;
    height: 24px;
  }
}
.header .header-container .header-button-touch .header-button-touch-pencil::after {
  content: "";
  width: 8px;
  height: 3px;
  position: absolute;
  bottom: 8.5px;
  right: 6.5px;
  background-color: #982D67;
  opacity: 0;
  transition-delay: 0.3s;
}
.header .header-container .header-button-touch:hover .header-button-touch-pencil {
  transform: rotate(-90deg);
}
.header .header-container .header-button-touch:hover .header-button-touch-pencil::after {
  opacity: 1;
  transition-delay: 0s;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAGA;EACI,WAAA;EACA,YAAA;EACA,yBCJS;EDKT,iBAAA;EACA,cCLI;EDMJ,eAAA;EACA,aAAA;EACA,UAAA;EACA,gFAAA;EEXA,aAAA;EACA,mBFWqB;EEVrB,uBFU0B;EET1B,mBFSkC;AACtC;AACI;EAZJ;IAaQ,YAAA;EAEN;AACF;AAAI;EAhBJ;IAiBQ,YAAA;EAGN;AACF;AADI;EACI,SAAA;AAGR;AAAI;EACI,UAAA;AAER;AACI;EACI,yBC3BC;AD4BT;AAEI;EACI,yBAAA;EACA,wBAAA;EACA,kBAAA;EErCJ,aAAA;EACA,mBFsCyB;EErCzB,8BFqC8B;EEpC9B,mBFoC6C;AAEjD;AAAQ;EAPJ;IAQQ,yBAAA;EAGV;AACF;AADQ;EAXJ;IAYQ,wBAAA;EAIV;AACF;AAFQ;EAfJ;IAgBQ,wBAAA;EAKV;AACF;AAHQ;EACI,gCAAA;AAKZ;AAFQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,yBC5DJ;ADgER;AADQ;EACI,YAAA;AAGZ;AADY;EAHJ;IAIQ,YAAA;EAId;AACF;AAFY;EACI,YAAA;AAIhB;AAAQ;EACI,WAAA;EACA,kBAAA;EE/ER,aAAA;EACA,mBF+E6B;EE9E7B,uBF8EkC;EE7ElC,mBF6E0C;AAK9C;AAHY;EALJ;IAMQ,WAAA;IACA,2BAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;IACA,OAAA;IACA,yBCrFP;IDsFO,8BAAA;EAMd;AACF;AALgB;EAfR;IAgBY,0BAAA;EAQlB;AACF;AApBY;EAcI;IACI,SAAA;EASlB;AACF;AARoB;EAHJ;IAIQ,SAAA;EAWtB;AACF;AAPY;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EE5GZ,aAAA;EACA,mBF4GiC;EE3GjC,uBF2GsC;EE1GtC,mBF0G8C;AAYlD;AAVgB;EANJ;IAOQ,0BAAA;IACA,kBAAA;IEjHhB,aAAA;IACA,sBFiHqC;IEhHrC,8BFgH6C;IE/G7C,uBF+G4D;EAgB9D;AACF;AAdgB;EAZJ;IAaQ,yBAAA;IACA,iBAAA;EAiBlB;AACF;AAfgB;EACI,UAAA;EACA,yBAAA;EE5HhB,aAAA;EACA,mBF4HqC;EE3HrC,8BF2H0C;EE1H1C,mBF0HyD;EEtHzD,yBFuHqC;EEtHrC,eFsHmD;EErHnD,kBFqHyD;EEpHzD,gBFoHiE;EEnHjE,iBFmHsE;AAwB1E;AAtBoB;EANJ;IEnHZ,yBF0HyC;IEzHzC,eFyHuD;IExHvD,kBFwH6D;IEvH7D,gBFuHqE;IEtHrE,iBFsH0E;EA6B5E;AACF;AA3BoB;EAVJ;IAWQ,SAAA;EA8BtB;AACF;AA5BoB;EAdJ;IAeQ,iBAAA;IACA,uBAAA;IACA,SAAA;IE3IpB,aAAA;IACA,sBF2IyC;IE1IzC,yBF0IiD;IEzIjD,uBFyI2D;IErI3D,yBFsIyC;IErIzC,eFqIuD;IEpIvD,kBFoI6D;IEnI7D,gBFmIqE;IElIrE,gBFkI0E;EAsC5E;AACF;AApCoB;EAtBJ;IAuBQ,iBAAA;IACA,uBAAA;IACA,SAAA;IE5IpB,yBF6IyC;IE5IzC,eF4IuD;IE3IvD,kBF2I6D;IE1I7D,gBF0IqE;IEzIrE,gBFyI0E;EA2C5E;AACF;AAzCoB;EACI,kBAAA;EACA,eAAA;AA2CxB;AAzCwB;EACI,gDAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,oCAAA;AA2C5B;AAxCwB;EACI,gDAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,oCAAA;AA0C5B;AAtCoB;;EAEI,UAAA;AAwCxB;AApCgB;EACI,aAAA;AAsCpB;AApCoB;EAHJ;IAIQ,cAAA;IACA,WAAA;EAuCtB;AACF;AApCgB;EACI,aAAA;AAsCpB;AApCoB;EAHJ;IAIQ,cAAA;IACA,iBAAA;IACA,SAAA;IEpMpB,aAAA;IACA,sBFoMyC;IEnMzC,8BFmMiD;IElMjD,uBFkMgE;EA0ClE;EAxCsB;IACI,sBAAA;IACA,yBAAA;IElMxB,yBFmM6C;IElM7C,eFkM2D;IEjM3D,kBFiMiE;IEhMjE,gBFgMyE;IE/LzE,iBF+L8E;EA8ChF;EA3CsB;IACI,SAAA;IACA,yBAAA;IE/MxB,aAAA;IACA,sBF+M6C;IE9M7C,8BF8MqD;IE7MrD,uBF6MoE;IEzMpE,yBF0M6C;IEzM7C,eFyM2D;IExM3D,kBFwMiE;IEvMjE,gBFuMyE;IEtMzE,iBFsM8E;EAoDhF;AACF;AAjDoB;EAvBJ;IAwBQ,iBAAA;IACA,SAAA;EAoDtB;EAlDsB;IACI,sBAAA;IACA,yBAAA;IEpNxB,yBFqN6C;IEpN7C,eFoN2D;IEnN3D,kBFmNiE;IElNjE,gBFkNyE;IEjNzE,iBFiN8E;EAwDhF;EArDsB;IACI,SAAA;IACA,yBAAA;IE1NxB,yBF2N6C;IE1N7C,eF0N2D;IEzN3D,kBFyNiE;IExNjE,gBFwNyE;IEvNzE,iBFuN8E;EA2DhF;AACF;AAvDgB;EACI,aAAA;AAyDpB;AAvDoB;EAHJ;IAIQ,WAAA;IACA,gBAAA;IE5OpB,aAAA;IACA,mBF4OyC;IE3OzC,2BF2O8C;IE1O9C,uBF0O0D;EA6D5D;EA3DsB;IACI,WAAA;EA6D1B;AACF;AA1DoB;EAbJ;IAcQ,gBAAA;EA6DtB;AACF;AAvDQ;EACI,QAAA;EE7PR,aAAA;EACA,mBF6P6B;EE5P7B,8BF4PkC;EE3PlC,mBF2PiD;AA4DrD;AA1DY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBClQR;EDmQQ,cCpQH;EDqQG,qBAAA;EACA,kCAAA;EACA,eAAA;EExQZ,aAAA;EACA,mBFwQiC;EEvQjC,uBFuQsC;EEtQtC,mBFsQ8C;AA+DlD;AA7DgB;EAXJ;IAYQ,aAAA;EAgElB;AACF;AA9DgB;EACI,kBAAA;EACA,UAAA;AAgEpB;AA7DgB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,yBCxRP;EDyRO,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yCAAA;EACA,sCAAA;EACA,wBAAA;AA+DpB;AA5DgB;EACI,cCjSZ;AD+VR;AA1DY;EACI,yCAAA;AA4DhB;AAzDY;EACI,aAAA;AA2DhB;AAzDgB;EAHJ;IAIQ,WAAA;IACA,YAAA;IACA,yBC/SZ;IDgTY,oBAAA;IACA,kBAAA;IACA,UAAA;IACA,eAAA;IErThB,aAAA;IACA,mBFqTqC;IEpTrC,uBFoT0C;IEnT1C,mBFmTkD;EA+DpD;AACF;AA3DQ;EACI,YAAA;EACA,sBAAA;EACA,yBC5TJ;ED6TI,cC9TC;ED+TD,SAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EErUR,aAAA;EACA,mBFqU6B;EEpU7B,uBFoUkC;EEnUlC,mBFmU0C;EE/T1C,yBFgU6B;EE/T7B,eF+T2C;EE9T3C,kBF8TiD;EE7TjD,gBF6TyD;EE5TzD,iBF4T8D;AAoElE;AAlEY;EAdJ;IAeQ,YAAA;EAqEd;AACF;AAnEY;EAlBJ;IAmBQ,aAAA;EAsEd;AACF;AA5DgB;EACI,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,qBAAA;AA8DpB;AA3DwB;EACI,yBAAA;AA6D5B;AAxDwB;EACI,UAAA;EACA,4BAAA;AA0D5B;AAtDoB;EACG,qBAAA;AAwDvB;AAjDY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBC3XH;ED4XG,qBAAA;EACA,sCAAA;EACA,wBAAA;EE/XZ,aAAA;EACA,mBF+XiC;EE9XjC,uBF8XsC;EE7XtC,mBF6X8C;AAsDlD;AApDgB;EAVJ;IAWQ,WAAA;IACA,YAAA;EAuDlB;AACF;AArDgB;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,yBC7YP;ED8YO,UAAA;EACA,sBAAA;AAuDpB;AAjDY;EACI,yBAAA;AAmDhB;AAjDgB;EACI,UAAA;EACA,oBAAA;AAmDpB","sourcesContent":["@use '../../styles/mixins.scss';\n@import '../../styles/variables.scss';\n\n.header {\n    width: 100%;\n    height: 72px;\n    background-color: $main-color;\n    padding-top: 20px;\n    color: $white;\n    position: fixed;\n    z-index: 1000;\n    top: -100%;\n    transition: top 1s cubic-bezier(0.4, 0, 0.2, 1), background-color 1s ease-in-out;\n    @include mixins.flex(row, center, center);\n\n    @media (min-width: 1620px) {\n        height: 80px;\n    }\n\n    @media (max-width: 550px) {\n        height: 60px;\n    }\n\n    &.visible {\n        top: -1px;\n    }\n\n    &.hide {\n        top: -100%;\n    }\n\n    &.open {\n        background-color: $purple;\n    }\n\n    .header-container {\n        width: calc(100% - 160px);\n        height: calc(100% - 2px);\n        position: relative;\n        // border-bottom: 2px solid $white;\n        @include mixins.flex(row, space-between, center);\n\n        @media (min-width: 1620px) {\n            width: calc(100% - 200px);\n        }\n\n        @media (max-width: 1050px) {\n            width: calc(100% - 80px);\n        }\n\n        @media (max-width: 550px) {\n            width: calc(100% - 32px);\n        }\n\n        &.border {\n            border-bottom: 2px solid $white;\n        }\n\n        .header-line {\n            width: 100%;\n            position: absolute;\n            top: 0px;\n            height: 2px;\n            background-color: $white;\n        }\n\n        .header-logo {\n            height: 20px;\n\n            @media (min-width: 1620px) {\n                height: 24px;\n            }\n\n            img {\n                height: 100%;\n            }\n        }\n\n        .header-navigator {\n            width: 100%;\n            position: absolute;\n            @include mixins.flex(row, center, center);\n\n            @media (max-width: 1050px) {\n                width: 100%;\n                height: calc(100svh - 92px);\n                position: fixed;\n                z-index: 999;\n                top: 100%;\n                left: 0;\n                background-color: $purple;\n                transition: top 1s ease-in-out;\n\n                @media (max-width: 550px) {\n                    height: calc(100vh - 79px);\n                }\n\n                &.open {\n                    top: 91px;\n\n                    @media (max-width: 550px) {\n                        top: 79px;\n                    }\n                }\n            }\n\n            .header-navigator-container {\n                width: 100%;\n                position: relative;\n                height: 100%;\n                @include mixins.flex(row, center, center);\n\n                @media (max-width: 1050px) {\n                    height: calc(100% - 104px);\n                    padding-top: 104px;\n                    @include mixins.flex(column, space-between, flex-start);\n                }\n\n                @media (max-width: 550px) {\n                    height: calc(100% - 52px);\n                    padding-top: 52px;\n                }\n\n                ul {\n                    gap: 112px;\n                    text-transform: uppercase;\n                    @include mixins.flex(row, space-between, center);\n                    @include mixins.font(FixelDisplay, 16px, normal, 500, 100%);\n    \n                    @media (min-width: 1620px) {\n                        @include mixins.font(FixelDisplay, 20px, normal, 500, 110%);\n                    }\n    \n                    @media (max-width: 1200px) {\n                        gap: 60px;\n                    }\n    \n                    @media (max-width: 1050px) {\n                        margin-left: 40px;\n                        letter-spacing: -1.92px;\n                        gap: 32px;\n                        @include mixins.flex(column, flex-end, flex-start);\n                        @include mixins.font(FixelDisplay, 64px, normal, 400, 90%);\n                    }\n\n                    @media (max-width: 550px) {\n                        margin-left: 16px;\n                        letter-spacing: -1.38px;\n                        gap: 24px;\n                        @include mixins.font(FixelDisplay, 46px, normal, 400, 90%);\n                    }\n    \n                    li {\n                        position: relative;\n                        cursor: pointer;\n    \n                        &::before {\n                            content: url('../../assets/nav-hover-icon.svg');\n                            position: absolute;\n                            top: -3px;\n                            left: -16px;\n                            opacity: 0;\n                            transition: opacity 0.3s ease-in-out;\n                        }\n    \n                        &::after {\n                            content: url('../../assets/nav-hover-icon.svg');\n                            position: absolute;\n                            top: 1px;\n                            right: -16px;\n                            transform: rotate(180deg);\n                            opacity: 0;\n                            transition: opacity 0.3s ease-in-out;\n                        }\n                    }\n    \n                    li:hover::before,\n                    li:hover::after {\n                        opacity: 1;\n                    }\n                }\n\n                .header-navigation-mobile-box {\n                    display: none;\n\n                    @media (max-width: 1050px) {\n                        display: block;\n                        width: 100%;\n                    }\n                }\n    \n                .header-navigator-contacts {\n                    display: none;\n    \n                    @media (max-width: 1050px) {\n                        display: block;\n                        margin-left: 40px;\n                        gap: 24px;\n                        @include mixins.flex(column, space-between, flex-start);\n    \n                        .header-navigator-contacts-label {\n                            letter-spacing: 0.14px;\n                            text-transform: uppercase;\n                            @include mixins.font(FixelDisplay, 14px, normal, 500, 110%);\n                        }\n    \n                        .header-navigator-contacts-box {\n                            gap: 16px;\n                            text-transform: uppercase;\n                            @include mixins.flex(column, space-between, flex-start);\n                            @include mixins.font(FixelDisplay, 34px, normal, 500, 110%);\n                        }\n                    }\n\n                    @media (max-width: 550px) {\n                        margin-left: 16px;\n                        gap: 24px;\n    \n                        .header-navigator-contacts-label {\n                            letter-spacing: 0.14px;\n                            text-transform: uppercase;\n                            @include mixins.font(FixelDisplay, 14px, normal, 500, 110%);\n                        }\n    \n                        .header-navigator-contacts-box {\n                            gap: 16px;\n                            text-transform: uppercase;\n                            @include mixins.font(FixelDisplay, 25px, normal, 500, 100%);\n                        }\n                    }\n                }\n    \n                .header-title {\n                    display: none;\n    \n                    @media (max-width: 1050px) {\n                        width: 100%;\n                        margin-top: 50px;\n                        @include mixins.flex(row, flex-start, flex-start);\n    \n                        img {\n                            width: 100%;\n                        }\n                    }\n\n                    @media (max-width: 1050px) {\n                        margin-top: 32px;\n                    }\n                }\n\n            }\n        }\n\n        .header-buttons-box {\n            gap: 8px;\n            @include mixins.flex(row, space-between, center);\n\n            .header-button-email {\n                width: 44px;\n                height: 44px;\n                position: relative;\n                background-color: $white;\n                color: $main-color;\n                border-radius: 1000px;\n                transition: color 0.3s ease-in-out;\n                cursor: pointer;\n                @include mixins.flex(row, center, center);\n\n                @media (max-width: 1050px) {\n                    display: none;\n                }\n                \n                svg {\n                    position: relative;\n                    z-index: 2;\n                }\n\n                &::before {\n                    content: '';\n                    width: 46px;\n                    height: 46px;\n                    border-radius: 1000px;\n                    background-color: $main-color;\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%, -50%) scale(0);\n                    transition: transform 0.3s ease-in-out;\n                    transform-origin: center;\n                }\n\n                &:hover {\n                    color: $white;\n                }\n            }\n\n            .header-button-email:hover::before {\n                transform: translate(-50%, -50%) scale(1);\n            }\n\n            .header-button-menu {\n                display: none;\n\n                @media (max-width: 1050px) {\n                    width: 40px;\n                    height: 40px;\n                    background-color: $white;\n                    border-radius: 100px;\n                    position: relative;\n                    z-index: 3;\n                    cursor: pointer;\n                    @include mixins.flex(row, center, center);\n                }\n            }\n        }\n\n        .header-button-touch {\n            height: 48px;\n            padding: 0 8px 0 130px;\n            background-color: $white;\n            color: $main-color;\n            gap: 12px;\n            border-radius: 1000px;\n            text-transform: uppercase;\n            position: relative;\n            z-index: 3;\n            cursor: pointer;\n            @include mixins.flex(row, center, center);\n            @include mixins.font(FixelDisplay, 16px, normal, 500, 110%);\n\n            @media (max-width: 1050px) {\n                height: 40px;\n            }\n\n            @media (max-width: 550px) {\n                display: none;            \n            }\n\n\n            // .header-button-touch-text-box {\n            //     width: 110px;\n            //     height: 16px;\n            //     position: relative;\n            //     overflow: hidden;\n            //     @include mixins.flex(row, center, center);\n\n                .header-button-touch-text {\n                    width: 110px;\n                    height: 16px;\n                    margin-top: 4px;\n                    overflow: hidden;\n                    white-space: nowrap;\n                    position: absolute;\n                    left: 15px;\n                    display: inline-block;\n\n                    &.top {\n                        .char {\n                            transform: translateY(0%);\n                        }\n                    }\n\n                    &.bottom {\n                        .char {\n                            opacity: 0;\n                            transform: translateY(-100%);\n                        }\n                    }\n\n                    .char {\n                       display: inline-block;\n                    }\n\n\n                }\n            // }\n\n            .header-button-touch-pencil {\n                width: 28px;\n                height: 28px;\n                position: relative;\n                background-color: $main-color;\n                border-radius: 1000px;\n                transition: transform 0.3s ease-in-out;\n                transform-origin: center;\n                @include mixins.flex(row, center, center);\n\n                @media (max-width: 1050px) {\n                    width: 24px;\n                    height: 24px;\n                }\n\n                &::after {\n                    content: '';\n                    width: 8px;\n                    height: 3px;\n                    position: absolute;\n                    bottom: 8.5px;\n                    right: 6.5px;\n                    background-color: $main-color;\n                    opacity: 0;\n                    transition-delay: 0.3s;\n                }\n            }\n        }\n\n        .header-button-touch:hover {\n            .header-button-touch-pencil {\n                transform: rotate(-90deg);\n\n                &::after {\n                    opacity: 1;\n                    transition-delay: 0s;\n                }\n            }\n        }\n    }\n}","// Colors\n\n$main-color: #982D67;\n$white: #FFFFFF;\n$light-background: #F5F5F5;\n$purple: #812456;\n$grey: #EAEAEA;\n$grey-opacity:#E0E0E0;\n$grey-dark: #575756;\n$grey-text: #BCBCBC;\n$dark: #313130;\n$red: #AE2323;\n$opacity-text: rgba(255, 255, 255, 0.50);","@mixin flex($dir, $jc, $ai) {\n    display: flex;\n    flex-direction: $dir;\n    justify-content: $jc;\n    align-items: $ai;\n}\n\n@mixin font ($font, $size, $style, $weight, $height) {\n    font-family: $font;\n    font-size: $size;\n    font-style: $style;\n    font-weight: $weight;\n    line-height: $height;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
